import { TYPE_NUMBER, TYPE_RANGE } from "@/constants/numberValueTypes";

class NumberValue {
    constructor(data = {}) {
        this.type = data.type === TYPE_RANGE ? TYPE_RANGE : TYPE_NUMBER;
        this.number = (data.number===null || isNaN(data.number)  ? "" : data.number).toString().trim();
        this.from = (data.from===null || isNaN(data.from)  ? "" : data.from).toString().trim();
        this.to = (data.to===null || isNaN(data.to)  ? "" : data.to).toString().trim();
    }

    get isRange() {
        return this.type === TYPE_RANGE;
    }

    get hasValue() {
        if (this.isRange) return this.from && this.to;
        return this.number;
    }

    get isCorrectRange() {
        if (!this.isRange) return true;
        return parseFloat(this.from) <= parseFloat(this.to);
    }
}

export default NumberValue;

export const NUMBER_VALUE_REQUIRED = "NumberValue/errors/required";
export const NUMBER_VALUE_RANGE = "NumberValue/errors/range";

export function validateNumberValue(value) {
    let error = null;

    if (!value.hasValue) error = NUMBER_VALUE_REQUIRED;
    else if (value.isRange && !value.isCorrectRange) {
        error = NUMBER_VALUE_RANGE;
    }

    return {
        error,
    };
}
